import { pickBy, isNil } from 'lodash';

/**
 * Based on vue-router's stringifyQuery function
 *
 * Link: https://github.com/vuejs/vue-router/blob/dev/src/util/query.js
 */
export function stringifyQuery(obj) {
    if(!obj) {
        return null;
    }

    const queryString = Object.keys(obj)
        .filter(key => !isNil(obj[key]))
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
        .join('&');

    if(queryString && queryString.length > 0) {
        return `?${queryString}`;
    }

    return '';
}

export const filterParams = (params) => pickBy(params, (value) => !isNil(value));



// WEBPACK FOOTER //
// ./src/helpers/url-helper.js